import { Component, Inject, ViewChild, AfterViewInit } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { DialogResult, DialogResultType } from "../DialogResult";
import { PreFilterSelectionComponent } from "../../elements/pre-filter-selection/pre-filter-selection.component";

export interface PreFilterEditorDialogData {
  preFilterId: number;
}

@Component({
  selector: "pre-filter-editor-dialog",
  styleUrls: ["./pre-filter-editor-dialog.component.html"],
  templateUrl: "./pre-filter-editor-dialog.component.html",
})
export class PreFilterEditorDialogComponent implements AfterViewInit {
  public Result: DialogResult;
  @ViewChild(PreFilterSelectionComponent) preFilterSelection!: PreFilterSelectionComponent;

  constructor(
    public dialogRef: MatDialogRef<PreFilterEditorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PreFilterEditorDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.preFilterSelection.savePreFilterValues().then(_ => {
      this.Result.ResultType = DialogResultType.Ok;
      this.dialogRef.close(this.Result);
    });
  }

  ngAfterViewInit(): void {
    this.preFilterSelection.loadCoreValues().then(_ => {
      this.preFilterSelection.loadPreFilterValues();
    });
  }

  static showDialog(
    dialog: MatDialog,
    preFilterId: number,
  ): Observable<any> {
    var params: PreFilterEditorDialogData = {
      preFilterId: preFilterId
    };

    var dialogRef = dialog.open(PreFilterEditorDialogComponent, {
      disableClose: true,
      width: "1400px",
      data: params,
    });

    return dialogRef.afterClosed();
  }
}
